import {
    SET_CLAIM_DATA,
    RESET_CLAIM_DATA,
    CLAIM_TYPE_NORMAL,
    SET_STEPS_FNOL,
    SET_STEPS_GLASS,
    SET_STEPS_DRIVABLE,
    SET_STEPS_DRIVABLE_STATIONARY,
    SET_STEPS_CELLPHONE,
    SET_STEPS_CELLPHONE_OTHER,
    SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE,
    SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE_STATIONARY,
    SET_STEPS_FOLLOW_UP_PEDESTRIAN,
    SET_STEPS_FOLLOW_UP_POTHOLE,
    INCIDENT_LOCATION_ID,
    CLAIM_OCCURANCE_AWAY_FROM_HOME,
    CLAIM_DAMAGE_CAUSE_PEDESTRIAN,
    CLAIM_DAMAGE_CAUSE_POTHOLE,
    CLAIM_DAMAGE_CAUSE_SINGLE_VEHICLE_STATIONARY,
    CLAIM_DAMAGE_CAUSE_MULTI_VEHICLE_STATIONARY,
    SET_STEPS_WARRANTY,
    SET_STEPS_CLAIMS_WARRANTY,
} from './../constants/constants';
import { isMobile } from 'react-device-detect';
import { ClaimGuiltyParties } from '../constants/Enums';


const initialState = {
    name: '',
    number: '',
    incidentDescription: '',
    incidentDate: "",
    incidentEventType: "",
    incidentEventList: [],
    isDrivable: false,
    isRecovered: false,
    lat: 0,
    lon: 0,
    selectedCover: [],
    selectedEvent: [],
    time: '',
    timeDisplay: '',
    claimNumber: '',
    IsIncidentDateClicked: false,
    currentStep: 1,
    fromPersonalSubmit: false,
    claimId: '',
    //ClaimV2
    claimsFAQs: [
        {
            processQuestionNumber: null,
            questionAnswer: "",
            questionText: "",
        }
    ],
    nextStepDescription: null,
    canNavigateToNextStep: false,
    selectedClaimProgressStep: null,
    claimProgress: null,
    isMobileInfo: false,
    isCar: false,
    hasDamageSelected: false,
    claimDamagePhotoTypes: [
        {
            id: 4,
            location: "front",
            description: "Front",
            imageName: "car-front",
            photoData: "",
            isSelected: true
        },
        {
            id: 5,
            location: "front",
            description: "Windscreen",
            imageName: "car-windscreen",
            photoData: "",
            isSelected: true
        },
        {
            id: 6,
            location: "front",
            description: "Bonnet",
            imageName: "car-bonnet",
            photoData: "",
            isSelected: true
        },
        {
            id: 7,
            location: "frontLeft",
            description: "Front left",
            imageName: "car-frontleft",
            photoData: "",
            isSelected: true
        },
        {
            id: 8,
            location: "frontLeft",
            description: "Front left door",
            imageName: "car-frontleftdoor",
            photoData: "",
            isSelected: true
        },
        {
            id: 9,
            location: "frontLeft",
            description: "Front left window",
            imageName: "car-frontleftwindow",
            photoData: "",
            isSelected: true
        },
        {
            id: 10,
            location: "frontLeft",
            description: "Front left tyre",
            imageName: "car-frontlefttyre",
            photoData: "",
            isSelected: true
        },
        {
            id: 11,
            location: "frontRight",
            description: "Front right",
            imageName: "car-frontright",
            photoData: "",
            isSelected: true
        },
        {
            id: 12,
            location: "frontRight",
            description: "Front right door",
            imageName: "car-frontrightdoor",
            photoData: "",
            isSelected: true
        },
        {
            id: 13,
            location: "frontRight",
            description: "Front right window",
            imageName: "car-frontrightwindow",
            photoData: "",
            isSelected: true
        },
        {
            id: 14,
            location: "frontRight",
            description: "Front right tyre",
            imageName: "car-frontrighttyre",
            photoData: "",
            isSelected: true
        },
        {
            id: 15,
            location: "backLeft",
            description: "Back left",
            imageName: "car-backleft",
            photoData: "",
            isSelected: true
        },
        {
            id: 16,
            location: "backLeft",
            description: "Back left door",
            imageName: "car-backleftdoor",
            photoData: "",
            isSelected: true
        },
        {
            id: 17,
            location: "backLeft",
            description: "Back left window",
            imageName: "car-backleftwindow",
            photoData: "",
            isSelected: true
        },
        {
            id: 18,
            location: "backLeft",
            description: "Back left tyre",
            imageName: "car-backlefttyre",
            photoData: "",
            isSelected: true
        },
        {
            id: 19,
            location: "backRight",
            description: "Back right",
            imageName: "car-backright",
            photoData: "",
            isSelected: true
        },
        {
            id: 20,
            location: "backRight",
            description: "Back right door",
            imageName: "car-backrightdoor",
            photoData: "",
            isSelected: true
        },
        {
            id: 21,
            location: "backRight",
            description: "Back right window",
            imageName: "car-backrightwindow",
            photoData: "",
            isSelected: true
        },
        {
            id: 22,
            location: "backRight",
            description: "Back right tyre",
            imageName: "car-backrighttyre",
            photoData: "",
            isSelected: true
        },
        {
            id: 23,
            location: "back",
            description: "Back",
            imageName: "car-back",
            photoData: "",
            isSelected: true
        },
        {
            id: 24,
            location: "back",
            description: "Back window",
            imageName: "car-backwindow",
            photoData: "",
            isSelected: true
        },
        {
            id: 25,
            location: "back",
            description: "Boot",
            imageName: "car-boot",
            photoData: "",
            isSelected: true
        },
        {
            id: 65,
            location: "special",
            description: "Undercarriage damage",
            imageName: "car-undercarriagedamage",
            photoData: "",
            isSelected: true
        },
        {
            id: 66,
            location: "special",
            description: "Interior",
            imageName: "car-interior",
            photoData: "",
            isSelected: true
        },
        {
            id: 67,
            location: "special",
            description: "Airbag popped",
            imageName: "car-airbagpopped",
            photoData: "",
            isSelected: true
        },
        {
            id: 68,
            location: "special",
            description: "Sunroof",
            imageName: "car-sunroof",
            photoData: "",
            isSelected: true
        },
        {
            id: 69,
            location: "special",
            description: "Roof",
            imageName: "car-roof",
            photoData: "",
            isSelected: true
        },
        {
            id: 70,
            location: "special",
            description: "Locks",
            imageName: "car-locks",
            photoData: "",
            isSelected: true
        },
    ],
    selectedDamagePhotoTypes: [],
    damageListCar: {
        damageFront: true,
        damageFrontLeft: true,
        damageFrontRight: true,
        damageBackLeft: true,
        damageBackRight: true,
        damageBack: true,
        damageExtras: true
    },
    selectedRiskItem: [],
    incidentType: "",
    mbFront: ["Front fairing", "Front mudguard", "Windshield", "Headlight", "Front tyre", "Handlebars", "Front brake"],
    mbFrontLeft: ["Left shock", "Left indicator", "Left mirror", "Left fairing", "Clutch lever", "Left front footrest", "Gear lever", "Front left brake"],
    mbFrontRight: ["Right shock", "Right indicator", "Right mirror", "Right fairing", "Front brake lever", "Right front footrest", "Right front brake"],
    mbBackLeft: ["Left side engine", "Left rear footrest", "Left side exhaust", "Left side frame", "Left rear indicator", "Left rear suspension", "Left rear brake"],
    mbBackRight: ["Right side engine", "Right rear footrest", "Right side exhaust", "Right side frame", "Right rear indicator", "Right rear suspension", "Right rear brake"],
    mbBack: ["Carrier", "Exhaust", "Tail light", "Rear fairing", "Rear mudguard", "Rear shock", "Rear tyre", "Rear brake"],
    isInEdit: false,
    photoList: "",
    incidentTime: "",
    contactName: "",
    contactNumber: "",
    whereDescription: "",
    address: "",
    addressLat: 0,
    addressLon: 0,
    addressDetail: { province: "", city: "", suburb: "", postalCode:"", formatted: "" },
    whatDescription: "",
    extraDescription: "",
    isDriveavle: false,
    lastCompletedStep: 1,
    lastCompletedSubStep: 1,
    isIncidentDateClicked: false,
    continueOnMobile: false,
    selectedClaim: [],
    otherThirdParties: [],
    pedestrians: [],
    passengers: [],
    witnesses: [],
    driverType: "",
    //FNOL
    isFnolClaim: false,
    fnolStep: 1,
    fnolSubStep: 1,
    nextFnolSubStep: 1,
    nextFnolStep: 1,
    claimType: CLAIM_TYPE_NORMAL,
    selectedClaimStep: { maxSubSteps: 4, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 4, title: "Claim info", subTitle: "We need a few details" },
    fnolStepConfiguration: {
        steps:
            []
    },
    showDisclaimer: false,
    claimStatus: "",
    hasSmashAndGrab: false,
    glassDamage: false,
    isRepaired: false,
    glassSubmitDisabled: true,
    hasBeenRepaired: false,
    claimExcess: 0.00,
    glassDrillDown: false,
    selectedGlassDrilldown: "",
    lastSelectedDamage: "",
    repairStepValid: false,
    replacementExcessDescription: "",
    repairExcessDescription: "",
    isStationary: "",
    regularDriver: "",
    driverDropdown: [],
    policeReported: null,
    policeReportNumber: "",
    policeReportStation: "",
    blackListed: null,
    blackListNumber: null,
    claimDriver: "",
    claimVehicleRegNo: "",
    vehicleRegistrationConfirm: false,
    isVehicleFinanced: "",
    selectedFinanceHouse: "",
    claimVehicleTypes: [],
    stolenLocations: [],
    forcedEntryType: [],
    contactPersonFullName: "Not given",
    contactPersonNumber: "",
    isResponsiblePersonMemberOfHousehold: null,
    responsiblePersonFullName: "Not given",
    responsiblePersonContactNumber: "",
    deliveryLocationLongitude: 0.00,
    deliveryLocationLatitude: 0.00,
    selectedTypeOfCarId: null,
    isVisibleSignsOfEntryIntoCar: null,
    selectedEntryGainedId: null,
    selectedWhereInTheCarId: null,
    newDeviceName: "",
    roadSurfaceTypes: [],
    selectedRoadSurfaceTypes: "",
    roadConditions: [],
    selectedRoadConditions: "",
    damageCauses: [],
    selectedDamageCauses: "",
    insuranceCompanies: [],
    selectedInsuranceCompany: "",
    claimGuiltyParty: undefined,
    damageCauseId: undefined,
    hasWitnesses: undefined,
    hasThirdParties: undefined,
    hasPassanger: undefined,
    hasPedestrian: undefined,
    thirdPartyUnknownReason: "",
    followUp: false,
    followUpType: "",
    potholePhotoTaken: undefined,
    partyErrorList: [],
    riskItemParkingAddress: "",
    claimParkingLocationId: INCIDENT_LOCATION_ID,
    claimOccuranceLocation: CLAIM_OCCURANCE_AWAY_FROM_HOME,
    hasInjuredParties: undefined,
    isDriverInjured: false,
}

const claimSubmitReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CLAIM_DATA:
            return {
                ...state,
                name: ('name' in action.payload) ? action.payload.name : state.name,
                number: ('number' in action.payload) ? action.payload.number : state.number,
                incidentDescription: ('incidentDescription' in action.payload) ? action.payload.incidentDescription : state.incidentDescription,
                incidentDate: ('incidentDate' in action.payload) ? action.payload.incidentDate : state.incidentDate,
                incidentEventType: ('incidentEventType' in action.payload) ? action.payload.incidentEventType : state.incidentEventType,
                isDrivable: ('isDrivable' in action.payload) ? action.payload.isDrivable : state.isDrivable,
                lat: ('lat' in action.payload) ? action.payload.lat : state.lat,
                lon: ('lon' in action.payload) ? action.payload.lon : state.lon,
                selectedCover: ('selectedCover' in action.payload) ? action.payload.selectedCover : state.selectedCover,
                selectedEvent: ('selectedEvent' in action.payload) ? action.payload.selectedEvent : state.selectedEvent,
                time: ('time' in action.payload) ? action.payload.time : state.time,
                timeDisplay: ('timeDisplay' in action.payload) ? action.payload.timeDisplay : state.timeDisplay,
                claimNumber: ('claimNumber' in action.payload) ? action.payload.claimNumber : state.claimNumber,
                IsIncidentDateClicked: ('IsIncidentDateClicked' in action.payload) ? action.payload.IsIncidentDateClicked : state.IsIncidentDateClicked,
                incidentEventList: ('incidentEventList' in action.payload) ? action.payload.incidentEventList : state.incidentEventList,
                currentStep: ('currentStep' in action.payload) ? action.payload.currentStep : state.currentStep,
                fromPersonalSubmit: ('fromPersonalSubmit' in action.payload) ? action.payload.fromPersonalSubmit : state.fromPersonalSubmit,
                claimId: ('claimId' in action.payload) ? action.payload.claimId : state.claimId,
                //ClaimV2Reducer
                isCar: ('isCar' in action.payload) ? action.payload.isCar : state.isCar,
                claimDamagePhotoTypes: ('claimDamagePhotoTypes' in action.payload) ? action.payload.claimDamagePhotoTypes : state.claimDamagePhotoTypes,
                selectedDamagePhotoTypes: ('selectedDamagePhotoTypes' in action.payload) ? action.payload.selectedDamagePhotoTypes : state.selectedDamagePhotoTypes,
                damageListCar: ('damageListCar' in action.payload) ? action.payload.damageListCar : state.damageListCar,
                selectedRiskItem: ('selectedRiskItem' in action.payload) ? action.payload.selectedRiskItem : state.selectedRiskItem,
                incidentType: ('incidentType' in action.payload) ? action.payload.incidentType : state.incidentType,
                mbFront: ('mbFront' in action.payload) ? action.payload.mbFront : state.mbFront,
                mbFrontLeft: ('mbFrontLeft' in action.payload) ? action.payload.mbFrontLeft : state.mbFrontLeft,
                mbFrontRight: ('mbFrontRight' in action.payload) ? action.payload.mbFrontRight : state.mbFrontRight,
                mbBackLeft: ('mbBackLeft' in action.payload) ? action.payload.mbBackLeft : state.mbBackLeft,
                mbBackRight: ('mbBackRight' in action.payload) ? action.payload.mbBackRight : state.mbBackRight,
                mbBack: ('mbBack' in action.payload) ? action.payload.mbBack : state.mbBack,
                isInEdit: ('isInEdit' in action.payload) ? action.payload.isInEdit : state.isInEdit,
                photoList: ('photoList' in action.payload) ? action.payload.photoList : state.photoList,
                hasDamageSelected: ('hasDamageSelected' in action.payload) ? action.payload.hasDamageSelected : state.hasDamageSelected,
                incidentTime: ('incidentTime' in action.payload) ? action.payload.incidentTime : state.incidentTime,
                contactName: ('contactName' in action.payload) ? action.payload.contactName : state.contactName,
                contactNumber: ('contactNumber' in action.payload) ? action.payload.contactNumber : state.contactNumber,
                whereDescription: ('whereDescription' in action.payload) ? action.payload.whereDescription : state.whereDescription,
                address: ('address' in action.payload) ? action.payload.address : state.address,
                addressLat: ('addressLat' in action.payload) ? action.payload.addressLat : state.addressLat,
                addressLon: ('addressLon' in action.payload) ? action.payload.addressLon : state.addressLon,
                addressDetail: ('addressDetail' in action.payload) ? action.payload.addressDetail : state.addressDetail,
                whatDescription: ('whatDescription' in action.payload) ? action.payload.whatDescription : state.whatDescription,
                extraDescription: ('extraDescription' in action.payload) ? action.payload.extraDescription : state.extraDescription,
                isDriveavle: ('isDriveavle' in action.payload) ? action.payload.isDriveavle : state.isDriveavle,
                continueOnMobile: ('continueOnMobile' in action.payload) ? action.payload.continueOnMobile : state.continueOnMobile,
                isIncidentDateClicked: ('isIncidentDateClicked' in action.payload) ? action.payload.isIncidentDateClicked : state.isIncidentDateClicked,
                lastCompletedStep: ('lastCompletedStep' in action.payload) ? action.payload.lastCompletedStep : state.lastCompletedStep,
                lastCompletedSubStep: ('lastCompletedSubStep' in action.payload) ? action.payload.lastCompletedSubStep : state.lastCompletedSubStep,
                claimProgress: ('claimProgress' in action.payload) ? action.payload.claimProgress : state.claimProgress,
                claimsFAQs: ('claimsFAQs' in action.payload) ? action.payload.claimsFAQs : state.claimsFAQs,
                selectedClaimProgressStep: ('selectedClaimProgressStep' in action.payload) ? action.payload.selectedClaimProgressStep : state.selectedClaimProgressStep,
                nextStepDescription: ('nextStepDescription' in action.payload) ? action.payload.nextStepDescription : state.nextStepDescription,
                canNavigateToNextStep: ('canNavigateToNextStep' in action.payload) ? action.payload.canNavigateToNextStep : state.canNavigateToNextStep,
                selectedClaim: ('selectedClaim' in action.payload) ? action.payload.selectedClaim : state.selectedClaim,
                isMobileInfo: ('isMobileInfo' in action.payload) ? action.payload.isMobileInfo : state.isMobileInfo,
                otherThirdParties: ('otherThirdParties' in action.payload) ? action.payload.otherThirdParties : state.otherThirdParties,
                pedestrians: ('pedestrians' in action.payload) ? action.payload.pedestrians : state.pedestrians,
                passengers: ('passengers' in action.payload) ? action.payload.passengers : state.passengers,
                witnesses: ('witnesses' in action.payload) ? action.payload.witnesses : state.witnesses,
                driverType: ('driverType' in action.payload) ? action.payload.driverType : state.driverType,
                //FNOL
                isFnolClaim: ('isFnolClaim' in action.payload) ? action.payload.isFnolClaim : state.isFnolClaim,
                fnolStep: ('fnolStep' in action.payload) ? action.payload.fnolStep : state.fnolStep,
                fnolSubStep: ('fnolSubStep' in action.payload) ? action.payload.fnolSubStep : state.fnolSubStep,
                showDisclaimer: ('showDisclaimer' in action.payload) ? action.payload.showDisclaimer : state.showDisclaimer,
                claimStatus: ('claimStatus' in action.payload) ? action.payload.claimStatus : state.claimStatus,
                hasSmashAndGrab: ('hasSmashAndGrab' in action.payload) ? action.payload.hasSmashAndGrab : state.hasSmashAndGrab,
                glassDamage: ('glassDamage' in action.payload) ? action.payload.glassDamage : state.glassDamage,
                isRepaired: ('isRepaired' in action.payload) ? action.payload.isRepaired : state.isRepaired,
                glassSubmitDisabled: ('glassSubmitDisabled' in action.payload) ? action.payload.glassSubmitDisabled : state.glassSubmitDisabled,
                hasBeenRepaired: ('hasBeenRepaired' in action.payload) ? action.payload.hasBeenRepaired : state.hasBeenRepaired,
                claimExcess: ('claimExcess' in action.payload) ? action.payload.claimExcess : state.claimExcess,
                claimType: ('claimType' in action.payload) ? action.payload.claimType : state.claimType,
                selectedClaimStep: ('selectedClaimStep' in action.payload) ? action.payload.selectedClaimStep : state.selectedClaimStep,
                glassDrillDown: ('glassDrillDown' in action.payload) ? action.payload.glassDrillDown : state.glassDrillDown,
                selectedGlassDrilldown: ('selectedGlassDrilldown' in action.payload) ? action.payload.selectedGlassDrilldown : state.selectedGlassDrilldown,
                lastSelectedDamage: ('lastSelectedDamage' in action.payload) ? action.payload.lastSelectedDamage : state.lastSelectedDamage,
                repairStepValid: ('repairStepValid' in action.payload) ? action.payload.repairStepValid : state.repairStepValid,
                replacementExcessDescription: ('replacementExcessDescription' in action.payload) ? action.payload.replacementExcessDescription : state.replacementExcessDescription,
                repairExcessDescription: ('repairExcessDescription' in action.payload) ? action.payload.repairExcessDescription : state.repairExcessDescription,
                isStationary: ('isStationary' in action.payload) ? action.payload.isStationary : state.isStationary,
                regularDriver: ('regularDriver' in action.payload) ? action.payload.regularDriver : state.regularDriver,
                driverDropdown: ('driverDropdown' in action.payload) ? action.payload.driverDropdown : state.driverDropdown,
                claimDriver: ('claimDriver' in action.payload) ? action.payload.claimDriver : state.claimDriver,
                claimVehicleRegNo: ('claimVehicleRegNo' in action.payload) ? action.payload.claimVehicleRegNo : state.claimVehicleRegNo,
                selectedFinanceHouse: ('selectedFinanceHouse' in action.payload) ? action.payload.selectedFinanceHouse : state.selectedFinanceHouse,
                isVehicleFinanced: ('isVehicleFinanced' in action.payload) ? action.payload.isVehicleFinanced : state.isVehicleFinanced,
                vehicleRegistrationConfirm: ('vehicleRegistrationConfirm' in action.payload) ? action.payload.vehicleRegistrationConfirm : state.vehicleRegistrationConfirm,
                policeReportNumber: ('policeReportNumber' in action.payload) ? action.payload.policeReportNumber : state.policeReportNumber,
                policeReportStation: ('policeReportStation' in action.payload) ? action.payload.policeReportStation : state.policeReportStation,
                claimVehicleTypes: ('claimVehicleTypes' in action.payload) ? action.payload.claimVehicleTypes : state.claimVehicleTypes,
                stolenLocations: ('stolenLocations' in action.payload) ? action.payload.stolenLocations : state.stolenLocations,
                forcedEntryType: ('forcedEntryType' in action.payload) ? action.payload.forcedEntryType : state.forcedEntryType,
                contactPersonFullName: ('contactPersonFullName' in action.payload) ? action.payload.contactPersonFullName : state.contactPersonFullName,
                contactPersonNumber: ('contactPersonNumber' in action.payload) ? action.payload.contactPersonNumber : state.contactPersonNumber,
                isResponsiblePersonMemberOfHousehold: ('isResponsiblePersonMemberOfHousehold' in action.payload) ? action.payload.isResponsiblePersonMemberOfHousehold : state.isResponsiblePersonMemberOfHousehold,
                responsiblePersonFullName: ('responsiblePersonFullName' in action.payload) ? action.payload.responsiblePersonFullName : state.responsiblePersonFullName,
                responsiblePersonContactNumber: ('responsiblePersonContactNumber' in action.payload) ? action.payload.responsiblePersonContactNumber : state.responsiblePersonContactNumber,
                deliveryLocationLongitude: ('deliveryLocationLongitude' in action.payload) ? action.payload.deliveryLocationLongitude : state.deliveryLocationLongitude,
                deliveryLocationLatitude: ('deliveryLocationLatitude' in action.payload) ? action.payload.deliveryLocationLatitude : state.deliveryLocationLatitude,
                policeReported: ('policeReported' in action.payload) ? action.payload.policeReported : state.policeReported,
                blackListed: ('blackListed' in action.payload) ? action.payload.blackListed : state.blackListed,
                blackListNumber: ('blackListNumber' in action.payload) ? action.payload.blackListNumber : state.blackListNumber,
                selectedTypeOfCarId: ('selectedTypeOfCarId' in action.payload) ? action.payload.selectedTypeOfCarId : state.selectedTypeOfCarId,
                isVisibleSignsOfEntryIntoCar: ('isVisibleSignsOfEntryIntoCar' in action.payload) ? action.payload.isVisibleSignsOfEntryIntoCar : state.isVisibleSignsOfEntryIntoCar,
                selectedEntryGainedId: ('selectedEntryGainedId' in action.payload) ? action.payload.selectedEntryGainedId : state.selectedEntryGainedId,
                selectedWhereInTheCarId: ('selectedWhereInTheCarId' in action.payload) ? action.payload.selectedWhereInTheCarId : state.selectedWhereInTheCarId,
                newDeviceName: ('newDeviceName' in action.payload) ? action.payload.newDeviceName : state.newDeviceName,
                roadSurfaceTypes: ('roadSurfaceTypes' in action.payload) ? action.payload.roadSurfaceTypes : state.roadSurfaceTypes,
                roadConditions: ('roadConditions' in action.payload) ? action.payload.roadConditions : state.roadConditions,
                insuranceCompanies: ('insuranceCompanies' in action.payload) ? action.payload.insuranceCompanies : state.insuranceCompanies,
                claimGuiltyParty: ('claimGuiltyParty' in action.payload) ? action.payload.claimGuiltyParty : state.claimGuiltyParty,
                damageCauseId: ('damageCauseId' in action.payload) ? action.payload.damageCauseId : state.damageCauseId,
                selectedRoadConditions: ('selectedRoadConditions' in action.payload) ? action.payload.selectedRoadConditions : state.selectedRoadConditions,
                selectedInsuranceCompany: ('selectedInsuranceCompany' in action.payload) ? action.payload.selectedInsuranceCompany : state.selectedInsuranceCompany,
                selectedRoadSurfaceTypes: ('selectedRoadSurfaceTypes' in action.payload) ? action.payload.selectedRoadSurfaceTypes : state.selectedRoadSurfaceTypes,
                damageCauses: ('damageCauses' in action.payload) ? action.payload.damageCauses : state.damageCauses,
                selectedDamageCauses: ('selectedDamageCauses' in action.payload) ? action.payload.selectedDamageCauses : state.selectedDamageCauses,
                hasWitnesses: ('hasWitnesses' in action.payload) ? action.payload.hasWitnesses : state.hasWitnesses,
                hasThirdParties: ('hasThirdParties' in action.payload) ? action.payload.hasThirdParties : state.hasThirdParties,
                hasPassanger: ('hasPassanger' in action.payload) ? action.payload.hasPassanger : state.hasPassanger,
                hasPedestrian: ('hasPedestrian' in action.payload) ? action.payload.hasPedestrian : state.hasPedestrian,
                thirdPartyUnknownReason: ('thirdPartyUnknownReason' in action.payload) ? action.payload.thirdPartyUnknownReason : state.thirdPartyUnknownReason,
                potholePhotoTaken: ('potholePhotoTaken' in action.payload) ? action.payload.potholePhotoTaken : state.potholePhotoTaken,
                partyErrorList: ('partyErrorList' in action.payload) ? action.payload.partyErrorList : state.partyErrorList,
                followUp: ('followUp' in action.payload) ? action.payload.followUp : state.followUp,
                followUpType: ('followUpType' in action.payload) ? action.payload.followUpType : state.followUpType,
                hasInjuredParties: ('hasInjuredParties' in action.payload) ? action.payload.hasInjuredParties : state.hasInjuredParties,
                riskItemParkingAddress: ('riskItemParkingAddress' in action.payload) ? action.payload.riskItemParkingAddress : state.riskItemParkingAddress,
                claimParkingLocationId: ('claimParkingLocationId' in action.payload) ? action.payload.claimParkingLocationId : state.claimParkingLocationId,
                claimOccuranceLocation: ('claimOccuranceLocation' in action.payload) ? action.payload.claimOccuranceLocation : state.claimOccuranceLocation,
                isDriverInjured: ('isDriverInjured' in action.payload) ? action.payload.isDriverInjured : state.isDriverInjured,
            }
        case RESET_CLAIM_DATA:
            return {
                ...state,
                name: '',
                number: '',
                incidentDescription: '',
                incidentDate: "",
                incidentEventType: "",
                incidentEventList: [],
                isDrivable: false,
                isRecovered: false,
                lat: 0,
                lon: 0,
                selectedCover: [],
                selectedEvent: [],
                time: '',
                timeDisplay: '',
                claimNumber: '',
                IsIncidentDateClicked: false,
                currentStep: 1,
                fromPersonalSubmit: false,
                claimId: '',
                //ClaimV2
                selectedClaimProgressStep: null,
                nextStepDescription: null,
                canNavigateToNextStep: false,
                claimProgress: null,
                claimsFAQs: [
                    {
                        processQuestionNumber: null,
                        questionAnswer: "",
                        questionText: "",
                    }
                ],
                isCar: false,
                hasDamageSelected: false,
                claimDamagePhotoTypes: [],
                selectedDamagePhotoTypes: [],
                damageListCar: [{
                    damageFront: true,
                    damageFrontLeft: false,
                    damageFrontRight: false,
                    damageBackLeft: false,
                    damageBackRight: false,
                    damageBack: false,
                    damageExtras: true
                }],

                selectedRiskItem: [],
                incidentType: "",
                mbFront: ["Front fairing", "Front mudguard", "Windshield", "Headlight", "Front tyre", "Handlebars", "Front brake"],
                mbFrontLeft: ["Left shock", "Left indicator", "Left mirror", "Left fairing", "Clutch lever", "Left front footrest", "Gear lever", "Front left brake"],
                mbFrontRight: ["Right shock", "Right indicator", "Right mirror", "Right fairing", "Front brake lever", "Right front footrest", "Right front brake"],
                mbBackLeft: ["Left side engine", "Left rear footrest", "Left side exhaust", "Left side frame", "Left rear indicator", "Left rear suspension", "Left rear brake"],
                mbBackRight: ["Right side engine", "Right rear footrest", "Right side exhaust", "Right side frame", "Right rear indicator", "Right rear suspension", "Right rear brake"],
                mbBack: ["Carrier", "Exhaust", "Tail light", "Rear fairing", "Rear mudguard", "Rear shock", "Rear tyre", "Rear brake"],
                isInEdit: false,
                photoList: "",
                incidentTime: "",
                contactName: "",
                contactNumber: "",
                whereDescription: "",
                address: "",
                addressLat: 0,
                addressLon: 0,
                addressDetail: { province: "", city: "", suburb: "", postalCode: "", formatted: "" },
                whatDescription: "",
                extraDescription: "",
                isDriveavle: false,
                lastCompletedStep: 1,
                lastCompletedSubStep: 1,
                continueOnMobile: false,
                selectedClaim: [],
                isMobileInfo: false,
                otherThirdParties: [],
                pedestrians: [],
                passengers: [],
                witnesses: [],
                driverType: "",
                //FNOL
                isFnolClaim: false,
                fnolStep: 1,
                fnolSubStep: 1,
                nextFnolSubStep: 1,
                nextFnolStep: 1,
                claimType: CLAIM_TYPE_NORMAL,
                selectedClaimStep: { maxSubSteps: 4, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 4, title: "Claim info", subTitle: "We need a few details" },
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 4, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 4, title: "Claim info", subTitle: "We need a few details" },
                            { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: "Where it happened", subTitle: "Share location details" },
                            { maxSubSteps: 1, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 1, title: "What happened", subTitle: "Describe how it happened" },
                            { maxSubSteps: 1, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 1, title: state.isCar ? "Drivable" : "Ridable", subTitle: state.isCar ? "Is your car drivable?" : "Is your motorbike ridable?" },
                            { maxSubSteps: 2, stepLabel: 5, step: 5, subStep: 1, maxMobileSubSteps: 2, title: "Damage report", subTitle: "Select damaged areas" },
                            { maxSubSteps: 0, stepLabel: 6, step: 6, subStep: 1, maxMobileSubSteps: 1, title: "Take photos", subTitle: "Take photos of damage" },
                            { maxSubSteps: 0, stepLabel: 7, step: 11, subStep: 1, maxMobileSubSteps: 0, title: "Complete", subTitle: "" }]
                },
                showDisclaimer: false,
                claimStatus: "",
                hasSmashAndGrab: false,
                glassDamage: false,
                isRepaired: false,
                glassSubmitDisabled: false,
                hasBeenRepaired: false,
                claimExcess: 0.00,
                stepLabel: 1,
                glassDrillDown: false,
                selectedGlassDrilldown: "",
                lastSelectedDamage: "",
                repairStepValid: false,
                replacementExcessDescription: "",
                repairExcessDescription: "",
                isStationary: "",
                regularDriver: "",
                driverDropdown: [],
                claimDriver: "",
                claimVehicleRegNo: "",
                vehicleRegistrationConfirm: false,
                isVehicleFinanced: "",
                selectedFinanceHouse: "",
                policeReportNumber: "",
                policeReportStation: "",
                claimVehicleTypes: [],
                stolenLocations: [],
                forcedEntryType: [],
                contactPersonFullName: "Not given",
                contactPersonNumber: "",
                isResponsiblePersonMemberOfHousehold: null,
                responsiblePersonFullName: "Not given",
                responsiblePersonContactNumber: "",
                deliveryLocationLongitude: 0.00,
                deliveryLocationLatitude: 0.00,
                blackListNumber: "",
                blackListed: null,
                policeReported: null,
                selectedTypeOfCarId: null,
                isVisibleSignsOfEntryIntoCar: null,
                selectedEntryGainedId: null,
                selectedWhereInTheCarId: null,
                newDeviceName: "",
                followUp: false,
                followUpType: "",
                roadSurfaceTypes: [],
                roadConditions: [],
                insuranceCompanies: [],
                claimGuiltyParty: undefined,
                damageCauseId: undefined,
                selectedRoadConditions: "",
                selectedInsuranceCompany: "",
                selectedRoadSurfaceTypes: "",
                damageCauses: [],
                selectedDamageCauses: "",
                hasWitnesses: undefined,
                hasThirdParties: undefined,
                hasPassanger: undefined,
                hasInjuredParties: undefined,
                hasPedestrian: undefined,
                thirdPartyUnknownReason: "",
                potholePhotoTaken: undefined,
                partyErrorList: [],
                riskItemParkingAddress: "",
                claimParkingLocationId: INCIDENT_LOCATION_ID,
                claimOccuranceLocation: CLAIM_OCCURANCE_AWAY_FROM_HOME,
                isDriverInjured: false,
            }
        case SET_STEPS_FNOL:
            return {
                ...state,
                isFnolClaim: true,
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 4, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 4, title: "Claim info", subTitle: "We need a few details" },
                            { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: "Where it happened", subTitle: "Share location details" },
                            { maxSubSteps: 1, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 1, title: "What happened", subTitle: "Describe how it happened" },
                            { maxSubSteps: 1, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 1, title: state.isCar ? "Drivable" : "Ridable", subTitle: state.isCar ? "Is your car drivable?" : "Is your motorbike ridable?" },
                            { maxSubSteps: 2, stepLabel: 5, step: 5, subStep: 1, maxMobileSubSteps: 2, title: "Damage report", subTitle: "Select damaged areas" },
                            { maxSubSteps: 0, stepLabel: 6, step: 6, subStep: 1, maxMobileSubSteps: 1, title: "Take photos", subTitle: "Take photos of damage" },
                            { maxSubSteps: 1, stepLabel: 6, step: 11, subStep: 1, maxMobileSubSteps: 1, title: "Complete", subTitle: "" }]
                },

            }
        case SET_STEPS_GLASS:
            return {
                ...state,
                selectedClaimStep: { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: 'Claim details', subTitle: 'We need a few details' },
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: 'Claim details', subTitle: 'We need a few details' },
                            { maxSubSteps: 1, stepLabel: 2, step: 3, subStep: 1, maxMobileSubSteps: 1, title: 'What happened', subTitle: 'Describe how it happened' },
                            { maxSubSteps: 1, stepLabel: 3, step: 5, subStep: 1, maxMobileSubSteps: 1, title: 'Damage report', subTitle: 'Select damaged areas' },
                            { maxSubSteps: 1, stepLabel: 4, step: 6, subStep: 1, maxMobileSubSteps: 1, title: 'Repairs/Replacement', subTitle: 'Share repair/replacement details' },
                            { maxSubSteps: 1, stepLabel: 5, step: 11, subStep: 1, maxMobileSubSteps: 1, title: 'Complete', subTitle: '' }
                        ]
                },
            }
        case SET_STEPS_CELLPHONE:
            return {
                ...state,
                selectedClaimStep: { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: 'Claim details', subTitle: 'We need a few details' },
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: 'Claim details', subTitle: 'We need a few details' },
                            { maxSubSteps: 1, stepLabel: 2, step: 6, subStep: 1, maxMobileSubSteps: 1, title: 'Repairs/Replacement', subTitle: 'Share repair/replacement details' },
                            { maxSubSteps: 1, stepLabel: 3, step: 11, subStep: 1, maxMobileSubSteps: 1, title: 'Complete', subTitle: '' }
                        ]
                },
            }
        case SET_STEPS_CELLPHONE_OTHER:
            return {
                ...state,
                selectedClaimStep: { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: 'Claim details', subTitle: 'We need a few details' },
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: 'Claim details', subTitle: 'We need a few details' },
                            { maxSubSteps: 1, stepLabel: 2, step: 11, subStep: 1, maxMobileSubSteps: 1, title: 'Complete', subTitle: '' }
                        ]
                },
            }
        case SET_STEPS_DRIVABLE:
            return {
                ...state,
                isFnolClaim: false,
                claimGuiltyParty: ClaimGuiltyParties.OtherParty,
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 4, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 4, title: "Claim info", subTitle: "We need a few details" },
                            { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: "Where it happened", subTitle: "Share location details" },
                            { maxSubSteps: 1, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 1, title: "What happened", subTitle: "Describe how it happened" },
                            { maxSubSteps: 1, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 1, title: state.isCar ? "Drivable" : "Ridable", subTitle: state.isCar ? "Is your car drivable?" : "Is your motorbike ridable?" },
                            { maxSubSteps: 2, stepLabel: 5, step: 5, subStep: 1, maxMobileSubSteps: 2, title: "Damage report", subTitle: "Select damaged areas" },
                            { maxSubSteps: 0, stepLabel: 6, step: 6, subStep: 1, maxMobileSubSteps: 1, title: "Take photos", subTitle: "Take photos of damage" },
                            { maxSubSteps: 1, stepLabel: isMobile ? 7 : 6, step: 7, subStep: 1, maxMobileSubSteps: 1, title: "Police report", subTitle: "Police report number" },
                            { maxSubSteps: 1, stepLabel: isMobile ? 8 : 7, step: 8, subStep: 1, maxMobileSubSteps: 1, title: state.isCar ? 'Driver details' : 'Rider details', subTitle: state.isCar ? 'Share who was driving the car' : 'Share who was riding the motorbike' },
                            { maxSubSteps: 1, stepLabel: isMobile ? 9 : 8, step: 9, subStep: 1, maxMobileSubSteps: 1, title: state.isCar ? 'Confirm car details' : 'Confirm motorbike details', subTitle: state.isCar ? 'Review your car details' : 'Review your motorbike details' },
                            { maxSubSteps: 2, stepLabel: isMobile ? 10 : 9, step: 10, subStep: 1, maxMobileSubSteps: 2, title: 'Finalise details', subTitle: '' }
                        ]
                },
            }
        case SET_STEPS_DRIVABLE_STATIONARY:
            return {
                ...state,
                isFnolClaim: false,
                claimGuiltyParty: ClaimGuiltyParties.OtherParty,
                damageCauseId: CLAIM_DAMAGE_CAUSE_SINGLE_VEHICLE_STATIONARY,
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 4, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 4, title: "Claim info", subTitle: "We need a few details" },
                            { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: "Where it happened", subTitle: "Share location details" },
                            { maxSubSteps: 1, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 1, title: "What happened", subTitle: "Describe how it happened" },
                            { maxSubSteps: 1, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 1, title: state.isCar ? "Drivable" : "Ridable", subTitle: state.isCar ? "Is your car drivable?" : "Is your motorbike ridable?" },
                            { maxSubSteps: 2, stepLabel: 5, step: 5, subStep: 1, maxMobileSubSteps: 2, title: "Damage report", subTitle: "Select damaged areas" },
                            { maxSubSteps: 0, stepLabel: 6, step: 6, subStep: 1, maxMobileSubSteps: 1, title: "Take photos", subTitle: "Take photos of damage" },
                            { maxSubSteps: 1, stepLabel: isMobile ? 7 : 6, step: 7, subStep: 1, maxMobileSubSteps: 1, title: "Police report", subTitle: "Police report number" },
                            { maxSubSteps: 1, stepLabel: isMobile ? 8 : 7, step: 9, subStep: 1, maxMobileSubSteps: 1, title: state.isCar ? 'Confirm car details' : 'Confirm motorbike details', subTitle: state.isCar ? 'Review your car details' : 'Review your motorbike details' },
                            { maxSubSteps: 2, stepLabel: isMobile ? 9 : 8, step: 10, subStep: 1, maxMobileSubSteps: 2, title: 'Finalise details', subTitle: '' }
                        ]
                },
            }
        case SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE:
            return {
                ...state,
                followUp: true,
                followUpType: "multiple-collision",
                showDisclaimer: false,
                selectedClaimStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: 'Incident Info', subTitle: 'We need a few more details' },
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: 'Incident info', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: 'Road surface', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 1, title: 'Other party/parties', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 1, title: 'Passengers/&witnesses', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 5, step: 5, subStep: 1, maxMobileSubSteps: 1, title: 'Injured party/parties', subTitle: 'We need a few more details' }
                        ]
                },
            }
        case SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE_STATIONARY:
            return {
                ...state,
                followUp: true,
                followUpType: "multiple-collision",
                showDisclaimer: false,
                claimGuiltyParty: ClaimGuiltyParties.OtherParty,
                selectedClaimStep: { maxSubSteps: 1, stepLabel: 1, step: 3, subStep: 1, maxMobileSubSteps: 1, title: 'Other party/parties', subTitle: 'We need a few more details' },
                damageCauseId: CLAIM_DAMAGE_CAUSE_MULTI_VEHICLE_STATIONARY,
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 1, stepLabel: 1, step: 3, subStep: 1, maxMobileSubSteps: 1, title: 'Other party/parties', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 2, step: 4, subStep: 1, maxMobileSubSteps: 1, title: 'Passengers/&witnesses', subTitle: 'We need a few more details' },
                        ]
                },
            }
        case SET_STEPS_FOLLOW_UP_PEDESTRIAN:
            return {
                ...state,
                followUp: true,
                followUpType: "pedestrian",
                showDisclaimer: false,
                claimGuiltyParty: ClaimGuiltyParties.OtherParty,
                damageCauseId: CLAIM_DAMAGE_CAUSE_PEDESTRIAN,
                selectedClaimStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: 'Road surface', subTitle: 'We need a few more details' },
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: 'Road surface', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: 'Pedestrians', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 3, step: 3, subStep: 1, maxMobileSubSteps: 1, title: 'Passengers/&witnesses', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 4, step: 4, subStep: 1, maxMobileSubSteps: 1, title: 'Injured party/parties', subTitle: 'We need a few more details' },
                        ]
                },
            }
        case SET_STEPS_FOLLOW_UP_POTHOLE:
            return {
                ...state,
                followUp: true,
                followUpType: "pothole",
                showDisclaimer: false,
                claimGuiltyParty: ClaimGuiltyParties.NotApplicable,
                damageCauseId: CLAIM_DAMAGE_CAUSE_POTHOLE,
                selectedClaimStep: { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: 'Road surface', subTitle: 'We need a few more details' },
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 1, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 1, title: 'Road surface', subTitle: 'We need a few more details' },
                            { maxSubSteps: 1, stepLabel: 2, step: 2, subStep: 1, maxMobileSubSteps: 1, title: 'Passengers/&witnesses', subTitle: 'We need a few more details' },
                        ]
                },
            }
        case SET_STEPS_CLAIMS_WARRANTY:
            return {
                ...state,
                selectedClaimStep: { maxSubSteps: 1, stepLabel: 1, step: 2, subStep: 1, maxMobileSubSteps: 1, title: 'Claim details', subTitle: 'We need a few details' },
                fnolStepConfiguration: {
                    steps:
                        [
                            { maxSubSteps: 1, stepLabel: 1, step: 2, subStep: 1, maxMobileSubSteps: 1, title: 'Claim details', subTitle: 'We need a few details' },
                            { maxSubSteps: 1, stepLabel: 2, step: 3, subStep: 1, maxMobileSubSteps: 1, title: 'Complete', subTitle: '' }
                        ]
                },
            }
        default:
            return state
    }
}

export default claimSubmitReducer;